var map = {
	"./chat_green.svg": 208,
	"./check_green.svg": 209,
	"./check_grey.svg": 210,
	"./cross_red.svg": 211,
	"./doc.svg": 212,
	"./img.svg": 213,
	"./other.svg": 73,
	"./pdf.svg": 214,
	"./xls.svg": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;